import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCartData } from './CartDataContext';
import { endKlinikaDoBooking } from '@/v2/utils/referralTracking';

export default function PathnameBridge() {
  const location = useLocation();
  const { setPathname } = useCartData();

  useEffect(() => {
    if (location.pathname === '/') endKlinikaDoBooking();
    setPathname(location.pathname);
  }, [location.pathname, setPathname]); // ✅ use pathname, not location

  return null;
}
